export default __webpack_public_path__ + "static/media/WNLProtoLap2.8b561c4f.png";